const sanitizeHtml = require("sanitize-html");
const DEFAULT_SOCIAL_TITLE = "monday.com is hiring!";
const DEFAULT_SOCIAL_DESCRIPTION = "we're on a mission to make people's work simpler, more productive and enjoyable. join monday.com and help us make it happen!";
const SANITIZE_OPTIONS = {
    allowedTags: [],
    allowedAttributes: []
};
export const parseSocialTitle = (rawTitle)=>{
    return rawTitle && rawTitle.value ? sanitizeHtml(rawTitle.value, SANITIZE_OPTIONS) : DEFAULT_SOCIAL_TITLE;
};
export const parseSocialDescription = (rawDescription)=>{
    return rawDescription && rawDescription.value ? sanitizeHtml(rawDescription.value, SANITIZE_OPTIONS) : DEFAULT_SOCIAL_DESCRIPTION;
};
